import { createRoute, lazyRouteComponent } from '@tanstack/react-router'

import { entryRoute } from './entry.tsx'
import { NAV_PATHS } from '../navigation/paths.ts'

// The club's wizard, one step past the fork. No guard: as /sign-up.
export const signUpClubRoute = createRoute({
  getParentRoute: () => entryRoute,
  path: NAV_PATHS.signUpClub,
  component: lazyRouteComponent(() => import('../pages/sign-up-club.tsx')),
})
